import {FC, useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import clsx from 'clsx';
import {useAuth} from 'app/modules/auth';
import {OpsFrameProvider, useOpsFrameBleeding} from 'app/ops-next/frame';
import AppAside from './components/aside/AppAside';
import {useAsideCollapsed} from './components/aside/useAsideCollapsed';
import AppHeader from './components/app-header/AppHeader';
import PageBar from './components/app-header/PageBar';
import {Toolbar} from './components/toolbar/Toolbar';
import {ScrollTop} from './components/ScrollTop';
import {Content} from './components/Content';
import {PageDataProvider} from './core';
import {useLocation} from 'react-router-dom';
import {MenuComponent} from '../assets/ts/components';

/**
 * A área de conteúdo do Metronic. Com uma tela Ops-Next na rota
 * (`OpsNextPage`), perde o recuo e a tela vai até as bordas (regra
 * `ops-content--bleed`, em `ops-next/styles/base.scss`).
 */
const KtContent: FC<{operation?: boolean}> = ({operation, children}) => {
  const bleed = useOpsFrameBleeding();

  return (
    <div
      id='kt_content'
      className={clsx(
        !operation && 'content',
        'd-flex flex-column flex-column-fluid',
        bleed && 'ops-content--bleed'
      )}
    >
      <Content>{children}</Content>
    </div>
  );
};

const MasterLayoutFrame = (props?: {operation?: boolean}) => {
  const location = useLocation();

  // Menu lateral aberto ou recolhido, escolha de cada pessoa
  const [asideCollapsed, toggleAside] = useAsideCollapsed(
    useAuth().currentUser?.uid
  );

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, [location.key]);

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root'>
        {/* begin::Page */}
        <div
          className='page d-flex flex-row flex-column-fluid'
          style={{height: '100vh', overflow: 'hidden'}}
        >
          <AppAside
            collapsed={asideCollapsed}
            onToggleCollapsed={toggleAside}
          />
          {/* begin::Wrapper */}
          <div
            className={clsx(
              'wrapper opx-appwrap d-flex flex-column flex-row-fluid',
              asideCollapsed && 'is-aside-collapsed'
            )}
            style={{overflowY: 'auto', height: '100vh'}}
            id='kt_wrapper'
          >
            {/* Header do app (igual em todas as telas) e, embaixo, a barra da
                página com as abas e ações que a tela declara */}
            <AppHeader asideCollapsed={asideCollapsed} />
            <PageBar />

            <Toolbar />

            {/* begin::Content */}
            <KtContent operation={props?.operation}>
              <Outlet />
            </KtContent>
            {/* end::Content */}
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Page */}
      </div>
      <ScrollTop />
    </PageDataProvider>
  );
};

// O provedor fica fora do layout: quem o lê (`KtContent`) está dentro dele, e
// cada layout (com e sem `operation`) tem o seu
const MasterLayout = (props?: {operation?: boolean}) => (
  <OpsFrameProvider>
    <MasterLayoutFrame operation={props?.operation} />
  </OpsFrameProvider>
);

export {MasterLayout};
